module.exports = __webpack_public_path__ + "media/img/hero-illustration-f52713fcd1446643b345a32c17c451fb.svg";